import { apiService } from "../../app.service";

export const usageApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getUsageSummary: builder.query({
      query: (params) => ({
        url: "/user/usage/summary",  // Will become: http://localhost:3000/api/v1/usage/summary
        method: "GET",
        params,
      }),
      providesTags: ["UsageSummary"],
    }),

    getRestaurantUsage: builder.query({
      query: (params) => ({
        url: "/user/usage/restaurants",
        method: "GET",
        params,
      }),
      providesTags: (result, error, { restaurantId }) => 
        [{ type: "RestaurantUsage", id: restaurantId }],
    }),

    getDetailedUsage: builder.query({
      query: (params) => ({
        url: "/user/usage/detailed",
        method: "GET",
        params,
      }),
      providesTags: ["DetailedUsage"],
    }),

    getChecklistTypeUsage: builder.query({
      query: ({ checklistType, ...params }) => ({
        url: `/user/usage/type/${checklistType}`,
        method: "GET",
        params,
      }),
      providesTags: (result, error, { checklistType }) => 
        [{ type: "TypeUsage", id: checklistType }],
    }),

    exportUsageReport: builder.mutation({
      query: (data) => ({
        url: "/user/usage/export",
        method: "POST",
        body: data,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetUsageSummaryQuery,
  useGetRestaurantUsageQuery,
  useGetDetailedUsageQuery,
  useGetChecklistTypeUsageQuery,
  useExportUsageReportMutation,
} = usageApi;